import { render, staticRenderFns } from "./RevenuesTypeTable.vue?vue&type=template&id=0688cfe0&"
import script from "./RevenuesTypeTable.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports